let mxPnl = {
    data() {
        return {
            nbWindow: 1,
            nbExteriorWall: 1,
            db:null,
        }
    },
    methods: {
        async calcPower() {
            this.db = await import('@/database/database')
            let powerToInstall=0;
            if (!this.state.known_power){
                let coeffCorrect = (this.nbWindow + this.nbExteriorWall)
                    * 0.1;
                let coeffK = this.db.coefficientK[this.state.house_type];
                let wantedTemp = this.db.roomsTemperature[this.state.room_type];
                let minTemp = this.state.selected_region.temp;
                let powerBefore = (wantedTemp - minTemp) * ((this.state.surface * 2.50) * coeffK);
                powerToInstall = powerBefore * (1 + coeffCorrect);
            }else{
                powerToInstall =this.state.power_selected;
            }
            return this.findConfigurationsByOption(powerToInstall);
        },
        async initCart(){

            console.log("INIT CART");

            this.state.radiator.thermostat = 'Sans fil'

            let ids = [];
            this.db = await import('@/database/wordpress_ids')

            if (this.state.piloting) {
                //if (this.state.radiator.thermostat == 'Sans fil'){
                    ids.push('1103')
                    ids.push('1118')
                //}else{
                    //ids.push('1102')
                //}
            }
            this.state.selected_config.radiatorsFetched.forEach(rad=>{
                ids.push(this.db.wordpressProducts.find(p=>{
                        let w
                        let h
                        if (this.state.radiator.orientation=='horizontal'){
                            w = rad.width
                            h = rad.height
                        }else{
                            w = rad.height
                            h = rad.width
                        }
                        // console.log(this.state.radiator.color.name.toLowerCase(),this.state.radiator.orientation.toLowerCase(),h,w,this.state.radiator.thermostat.toLowerCase(),rad.power,this.state.radiator.finition.toLowerCase())
                        // console.log(p.color.toLowerCase(),p.orientation.toLowerCase(),p.height,p.length,p.thermostat.toLowerCase(),p.power,p.finition.toLowerCase(),p.UGS)
                        return p.power.includes(rad.power)&&
                        p.color.toLowerCase()==this.state.radiator.color.name.toLowerCase()
                        &&p.finition.toLowerCase()==this.state.radiator.finition.toLowerCase()
                        &&p.orientation.toLowerCase()==this.state.radiator.orientation.toLowerCase()
                        &&p.height==h
                        &&p.length==w
                        &&p.thermostat.toLowerCase()==this.state.radiator.thermostat.toLowerCase()
                }).ID
                )
                if (parseInt(this.state.radiator.towelDryers)>0){
                    switch (parseInt(this.state.radiator.towelDryers)) {
                        case 2:{
                            if(rad.height==45)ids.push('1106')
                            else ids.push('1108')
                            break;
                        }
                        case 3:{
                            if(rad.height==45)ids.push('1107')
                            else ids.push('1109')
                            break;
                        }
                    }
                }
            })
            return ids;

        },
        findRadiatorById(id){
            return this.db.radiators.find(r => r.id==id);
        },
        findConfigurationsByOption(option) {
            try {
                let array = [];
                if (this.state.room_type=='cuisine'||this.state.room_type=='salle-de-bain')array = this.db.alternativeConfigurationsTowels;
                else array = this.db.alternativeConfigurations;
                let configurations = array.filter(o => {
                    if (parseInt(option) > 4800) return o["power"] === 4800;
                    return o["power"] >= parseInt(option)
                });
                configurations = array.filter(o => {
                    return o["power"] == configurations[0]["power"]
                });

                configurations.forEach(c=>{
                    let rads=[];
                    let orientable = true;
                    let excluded_colors = [];
                   c.radiators.forEach(r=>{
                       let rad = this.findRadiatorById(r)
                       if (!rad.orientable)orientable = false;
                       excluded_colors = excluded_colors.concat(rad.excluded_colors)
                       rads.push(rad);
                   })
                    c.orientable = orientable;
                    c.excluded = excluded_colors;
                    c.radiatorsFetched = rads;
                });
                return configurations;
            } catch (e) {
                console.error("Issue when trying to parse the option value to find it's corresponding alternative solutions.", e.message);
                return null;
            }
        }

    }
}
export default mxPnl;